/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Navigate } from "react-router-dom";
import authRoles from "../../auth/authRoles";
import Organizations from "./Organizations";
import InstanceWrapper from "../../shared-components/layouts/InstanceWrapper";
import OrganizationForm from "./instance/OrganizationForm";

const OrganizationsConfig = {
  routes: [
    {
      path: "organizations",
      element: <Organizations />,
    },
    {
      path: "organizations/:id",
      element: <InstanceWrapper />,
      children: [
        {
          path: "edit",
          element: <OrganizationForm />,
          auth: authRoles.admin,
        },
        {
          path: "",
          element: <Navigate to='/organizations' />,
        },
        {
          path: "*",
          element: <Navigate to='/organizations' />,
        },
      ],
    },
  ],
};

export default OrganizationsConfig;
